import { EyeIcon, EyeSlashIcon } from '@heroicons/react/20/solid';
import { t } from 'i18next';
import React, { useState } from 'react';
import { FieldValues } from 'react-hook-form';
import * as yup from 'yup';

import { TextInput } from 'core/components/form';
import { DefaultFormInputProps } from 'core/components/form/types';
import { TextInputProps } from 'core/components/uikit/inputs/TextInput';

export const createPasswordInputSchema = ({ name }: { name: string }) =>
  yup
    .string()
    .required(
      t('errors.validation.isRequired', {
        name,
      })
    )
    .min(
      8,
      t('errors.validation.minLength', {
        name,
        length: 8,
      })
    )
    .matches(
      /[A-Z]/,
      t('errors.validation.password.uppercase', {
        name,
      })
    )
    .matches(
      /[a-z]/,
      t('errors.validation.password.lowercase', {
        name,
      })
    )
    .matches(
      /\d/,
      t('errors.validation.password.number', {
        name,
      })
    )
    .matches(
      /[@$!%*?&_-]/,
      t('errors.validation.password.specialCharacter', {
        name,
      })
    );

const PasswordInput = <FormValues extends FieldValues>({
  componentProps,
  ...input
}: DefaultFormInputProps<FormValues, TextInputProps>) => {
  const [showPassword, setShowPassword] = useState(false);

  const renderPasswordIcon = () => {
    return showPassword ? (
      <EyeSlashIcon
        className="h-5 w-5 cursor-pointer text-slate-500"
        onClick={() => setShowPassword(false)}
      />
    ) : (
      <EyeIcon
        className="h-5 w-5 cursor-pointer text-slate-500"
        onClick={() => setShowPassword(true)}
      />
    );
  };

  return (
    <TextInput
      {...input}
      componentProps={{
        type: showPassword ? 'text' : 'password',
        renderIcon: renderPasswordIcon,
        ...componentProps,
      }}
    />
  );
};

export default PasswordInput;
